// Mirrors the server side 'FreeMarkerValidator' in 'forms'.
// Every '${' has to start a placeholder like '${name}', '${user.name}' or '${_hideWhenHidden("work")}'.

// Kept close to the server side pattern (including its leniency, e.g. '${a-b}'), so we never reject what it accepts
const VALID_PLACEHOLDER = /^\$\{[\p{L}+_][\p{L}+0-9_.]*\(?'?[\p{L}+0-9\-_.]*'?\)?\}$/u;

// Everything that looks like a placeholder: up to the closing brace, or only the first word when it is never closed.
// Stopping at '<', a new line or another '$' keeps an unclosed placeholder from swallowing the HTML that follows it.
const PLACEHOLDER_CANDIDATE = /\$\{(?:[^${}<\n]*\}|[^\s${}<]*)/gu;

export type InvalidPlaceholder = {
  text: string;
  from: number;
  to: number;
  line: number;
};

const lineAt = (input: string, index: number) => input.slice(0, index).split("\n").length;

export const findInvalidPlaceholders = (input: string, subformDataNames: string[] = []): InvalidPlaceholder[] => {
  const forbiddenPrefixes = subformDataNames.map((dataName) => `\${${dataName}.`.toLowerCase());
  const isForbidden = (text: string) => forbiddenPrefixes.some((prefix) => text.toLowerCase().startsWith(prefix));

  return Array.from(input.matchAll(PLACEHOLDER_CANDIDATE))
    .filter(([text]) => !VALID_PLACEHOLDER.test(text) || isForbidden(text))
    .map(({ 0: text, index: from }) => ({ text, from, to: from + text.length, line: lineAt(input, from) }));
};
